import { FC } from "react";
import { ToastContentProps } from "react-toastify";
import { Flex } from "shared/ui/flex";
import { Typography } from 'shared/ui/typography';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';

type DownloadNotificationProps = {
  onClick: () => void;
}

export const DownloadNotification: FC<ToastContentProps<DownloadNotificationProps>> = ({
  closeToast,
  data
}) => {

  const onClick = () => {
    data.onClick();
    closeToast()
  }

  return (
    <Flex
      $gap="8px"
      $alignItems="center"
      $justify="space-between"
    >
      <Typography>
        Файл готов
      </Typography>
      <ButtonOutlined
        onClick={onClick}
      >
        Скачать
      </ButtonOutlined>
    </Flex>
  )
}